export { getOverlap, hasOverlap } from './overlap';
